<template>
    <div class="containerRepresentante">
        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
        </div>
        <div class="formulario">
            <div class="agrupamentoFormulario" style="border-bottom: 1px solid #D0D5DD;">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Administrador'" :TipoCliente="'Fundos'" :Sessao="'Participantes'" :SubSessao="'Administrador'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 60%">
                            <label class="label" for="razaoSocial">Denominação social (sem abreviações)*</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmenteParticipante" v-model="participante.Administrador" id="razaoSocial">
                            <p v-if="camposObrigatorios.erroParticipanteAdministrador" class="erro">Campo obrigatório.</p>
                        </div>
                        <div class="label__field" style="width: 40%">
                            <label class="label" for="cnpj">CNPJ*</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmenteParticipante" v-model="participante.AdministradorCnpj" id="cnpj" placeholder="00.000.000/0000-00">
                            <p v-if="camposObrigatorios.erroParticipanteAdministradorCnpj" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div v-for="(representante, index) in representantes" :key="representante.Guid" class="empresaItem" style="border-bottom: 1px solid #EAECF0;">
                        <div class="row" v-if="representante.Tipo == 'representanteAdministrador'">
                            <div class="label__field" style="width: 40%">
                                <label class="label" for="cpf">Representante legal*</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteRepresentante" v-model="representante.Nome" id="representanteLegal">
                                <p v-if="camposObrigatoriosRepresentante[index]?.erroNome && tentativaPostagem" class="erro">Campo obrigatório.</p>
                            </div>
                            <div class="label__field" style="width: 20%">
                                <label class="label" for="dataConstituicao">CPF*</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteRepresentante" v-model="representante.CpfCnpj" id="cpfRepre" placeholder="000.000.000-00">
                                <p v-if="camposObrigatoriosRepresentante[index]?.erroCpfCnpj && tentativaPostagem" class="erro">Campo obrigatório.</p>
                            </div>
                            <div class="label__field" style="width: 20%">
                                <label class="label" for="dataConstituicao">Telefone</label>
                                <input class="field" autocomplete="off" type="text" @change="salvarAlteracoesLocalmenteRepresentante" v-model="representante.Telefone" id="telefoneRepr" v-mask="'(##) #####-####'" placeholder="(**) ****-*****">
                            </div>
                        </div>
                        <div class="row" v-if="representante.Tipo == 'representanteAdministrador'">
                            <div class="label__field" style="width: 40%">
                                <label class="label" for="dataConstituicao">E-mail</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteRepresentante" v-model="representante.Email">
                            </div>
                            <div class="label__field" style="width: 20%">
                                <label class="label" for="dataConstituicao">Cargo</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteRepresentante" v-model="representante.Cargo">
                            </div>
                            <div class="label__field" style="width: 20%">
                                <label class="label" for="dataConstituicao">É signatário?</label>
                                <div class="radio">
                                    <input type="radio" id="signatario" value="false" :name="'Signatario_Adm_Nao' + index" class="field__radio" v-model="representante.Signatario" @change="salvarAlteracoesLocalmenteRepresentante" />
                                    <label :for="'Signatario_Adm_Nao' + index" class="label__radio">Não</label>
                                    <input type="radio" id="signatario" value="true" :name="'Signatario_Adm_Sim' + index" class="field__radio" v-model="representante.Signatario" @change="salvarAlteracoesLocalmenteRepresentante" />
                                    <label :for="'Signatario_Adm_Sim' + index" class="label__radio">Sim</label>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="representante.Tipo == 'representanteAdministrador'">
                            <div class="label__field" style="width: 40%">
                                <label class="label" for="assinatura">Assinatura*</label>
                                <select id="assinante" class="field" @change="salvarAlteracoesLocalmenteRepresentante" v-model="representante.Assinatura">
                                    <option value=""></option>
                                    <option value="1">Não assina pela empresa</option>
                                    <option value="2">Assina isoladamente</option>
                                    <option value="0">Assina em conjunto</option>
                                </select>
                                <p v-if="camposObrigatoriosRepresentante[index]?.erroAssinatura && tentativaPostagem" class="erro">Campo obrigatório.</p>
                            </div>
                            <div class="label__field" v-if="index > 0" style="width: 5%; margin-top: 30px">
                                <a @click.stop.prevent="excluirRepresentante(index)" class="ico__delete" title="Excluir representante">
                                    <Icon icon="ico-delete" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="buttonsAcoes" style="margin-bottom: 10px;">
                        <button class="btnDefault" @click="addRepresentanteAdmin">+ Adicionar mais</button>
                    </div>
                </div>
            </div>
            <div class="agrupamentoFormulario" style="border-bottom: 1px solid #D0D5DD;">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Gestor'" :TipoCliente="'Fundos'" :Sessao="'Participantes'" :SubSessao="'Gestor'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 60%">
                            <label class="label" for="razaoSocial">Denominação social ou Nome completo (sem abreviações)*</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmenteParticipante" v-model="participante.Gestor" id="razaoSocial">
                            <p v-if="camposObrigatorios.erroParticipanteGestor" class="erro">Campo obrigatório.</p>
                        </div>
                        <div class="label__field" style="width: 40%">
                            <label class="label" for="cnpj">CNPJ*</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmenteParticipante" v-model="participante.GestorCnpj" id="cnpj" placeholder="00.000.000/0000-00">
                            <p v-if="camposObrigatorios.erroParticipanteGestorCnpj" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div v-for="(representante, index) in representantes" :key="representante.Guid" class="empresaItem" style="border-bottom: 1px solid #EAECF0;">
                        <div class="row" v-if="representante.Tipo == 'gestor' || representante.Tipo == 'Gestor'">
                            <div class="label__field" style="width: 40%">
                                <label class="label" for="representanteLegal">Representante legal*</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteRepresentante" v-model="representante.Nome" id="representanteLegal">
                                
                            </div>
                            <div class="label__field" style="width: 20%">
                                <label class="label" for="dataConstituicao">CPF*</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteRepresentante" v-model="representante.CpfCnpj" id="dataConstituicao" placeholder="000.000.000-00">
                                
                            </div>
                            <div class="label__field" style="width: 20%">
                                <label class="label" :for="'telefoneRepr' + index">Telefone</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteRepresentante" v-model="representante.Telefone" :id="'telefoneRepr' + index" v-mask="'(##) #####-####'" placeholder="(**) ****-*****">
                            </div>
                        </div>
                        <div class="row" v-if="representante.Tipo == 'gestor' || representante.Tipo == 'Gestor'">
                            <div class="label__field" style="width: 40%">
                                <label class="label" for="dataConstituicao">E-mail</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteRepresentante" v-model="representante.Email">
                            </div>
                            <div class="label__field" style="width: 20%">
                                <label class="label" for="dataConstituicao">Cargo</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteRepresentante" v-model="representante.Cargo">
                            </div>
                            <div class="label__field" style="width: 20%">
                                <label class="label" for="dataConstituicao">É signatário?</label>
                                <div class="radio">
                                    <input type="radio" id="signatario" value="false" :name="'Signatario_Nao' + index" class="field__radio" v-model="representante.Signatario" @change="salvarAlteracoesLocalmenteRepresentante" />
                                    <label :for="'Signatario_Nao' + index" class="label__radio">Não</label>
                                    <input type="radio" id="signatario" value="true" :name="'Signatario_Sim' + index" class="field__radio" v-model="representante.Signatario" @change="salvarAlteracoesLocalmenteRepresentante" />
                                    <label :for="'Signatario_Sim' + index" class="label__radio">Sim</label>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="representante.Tipo == 'gestor' || representante.Tipo == 'Gestor'">
                            <div class="label__field" style="width: 40%">
                                <label class="label" for="assinatura">Assinatura*</label>
                                <select id="assinante" class="field" @change="salvarAlteracoesLocalmenteRepresentante" v-model="representante.Assinatura">
                                    <option value=""></option>
                                    <option value="1">Não assina pela empresa</option>
                                    <option value="2">Assina isoladamente</option>
                                    <option value="0">Assina em conjunto</option>
                                </select>
                                
                            </div>
                            <div class="label__field" v-if="index > 0" style="width: 5%; margin-top: 30px">
                                <a @click.stop.prevent="excluirRepresentante(index)" class="ico__delete" title="Excluir representante">
                                    <Icon icon="ico-delete" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="buttonsAcoes" style="margin-bottom: 10px;">
                        <button class="btnDefault" @click="addRepresentanteGestor">+ Adicionar mais</button>
                    </div>
                </div>
            </div>
            <div class="agrupamentoFormulario" style="border-bottom: 1px solid #D0D5DD;">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Emissor de Ordem'" :TipoCliente="'Fundos'" :Sessao="'Participantes'" :SubSessao="'Emissor de Ordem'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div v-for="(emissorOrdem, index) in emissoresDeOrdens" :key="emissorOrdem.Guid" class="empresaItem" style="  border-bottom: 1px solid #EAECF0;">
                        <div class="row">
                            <div class="label__field" style="width: 60%">
                                <label class="label" for="razaoSocial">Denominação social ou Nome completo (sem abreviações)*</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteEmissorOrdem" v-model="emissorOrdem.Nome" id="NomeEmissor">
                                <p v-if="camposObrigatoriosEmissor[index]?.erroNome && tentativaPostagem" class="erro">Campo obrigatório.</p>
                            </div>
                            <div class="label__field" style="width: 40%">
                                <label class="label" for="cnpj">CNPJ*</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteEmissorOrdem" v-model="emissorOrdem.CpfCnpj" id="cnpj" placeholder="00.000.000/0000-00">
                                <p v-if="camposObrigatoriosEmissor[index]?.erroCpfCnpj && tentativaPostagem" class="erro">Campo obrigatório.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="label__field" style="width: 33%">
                                <label class="label" for="emailEmissorOrdem">Email</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteEmissorOrdem" v-model="emissorOrdem.Email" id="emailEmissorOrdem">
                            </div>
                            <div class="label__field" style="width: 33%">
                                <label class="label" for="telefoneEmissorOrdem">Telefone</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteEmissorOrdem" v-model="emissorOrdem.Telefone" v-mask="'(##) #####-####'" placeholder="(**) ****-*****" id="telefoneEmissorOrdem">
                            </div>
                            <div class="label__field" style="width: 33%">
                                <label class="label" for="assinatura">Assinatura*</label>
                                <select id="assinante" class="field" @change="salvarAlteracoesLocalmenteRepresentante" v-model="emissorOrdem.Assinatura">
                                    <option value=""></option>
                                    <option value="1">Não assina pela empresa</option>
                                    <option value="2">Assina isoladamente</option>
                                    <option value="0">Assina em conjunto</option>
                                </select>
                                <p v-if="camposObrigatoriosEmissor[index]?.erroAssinatura && tentativaPostagem" class="erro">Campo obrigatório.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="label__field" style="width: 20%">
                                <label class="label" for="dataConstituicao">Considerado US Person?</label>
                                <div class="radio">
                                    <input type="radio" :id="'UsPerson_Nao' + index" value="false" :name="'UsPerson_Nao' + index" class="field__radio" v-model="emissorOrdem.UsPerson" @change="salvarAlteracoesLocalmenteEmissorOrdem" />
                                    <label :for="'UsPerson_Nao' + index" class="label__radio">Não</label>
                                    <input type="radio" :id="'UsPerson_Sim' + index" value="true" :name="'UsPerson_Sim' + index" class="field__radio" v-model="emissorOrdem.UsPerson" @change="salvarAlteracoesLocalmenteEmissorOrdem" />
                                    <label :for="'UsPerson_Sim' + index" class="label__radio">Sim</label>
                                </div>
                            </div>
                            <div class="label__field" style="width: 20%">
                                <label class="label" for="dataConstituicao">Politicamente Exposto?</label>
                                <div class="radio">
                                    <input type="radio" :id="'PoliticamenteExposta_Nao' + index" value="false" :name="'PoliticamenteExposta_Nao' + index" class="field__radio" v-model="emissorOrdem.PoliticamenteExposta" @change="salvarAlteracoesLocalmenteEmissorOrdem" />
                                    <label :for="'PoliticamenteExposta_Nao' + index" class="label__radio">Não</label>
                                    <input type="radio" :id="'PoliticamenteExposta_Sim' + index" value="true" :name="'PoliticamenteExposta_Sim' + index" class="field__radio" v-model="emissorOrdem.PoliticamenteExposta" @change="salvarAlteracoesLocalmenteEmissorOrdem" />
                                    <label :for="'PoliticamenteExposta_Sim' + index" class="label__radio">Sim</label>
                                </div>
                            </div>
                            <div class="label__field" v-if="index > 0" style="width: 20%; margin-top: 30px">
                                <a @click.stop.prevent="excluirEmissorOrdem(index)" class="ico__delete" title="Excluir emissor de ordem">
                                    <Icon icon="ico-delete" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="buttonsAcoes" style="margin-bottom: 10px;">
                        <button class="btnDefault" @click="addEmisorOrdem">+ Adicionar mais</button>
                    </div>
                </div>
            </div>
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Custodiante'" :TipoCliente="'Fundos'" :Sessao="'Participantes'" :SubSessao="'Custodiante'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 60%">
                            <label class="label" for="razaoSocial">Denominação social ou Nome completo (sem abreviações)*</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmenteParticipante" v-model="participante.Custodiante" id="razaoSocial">
                            <p v-if="camposObrigatorios.erroParticipanteCustodiante" class="erro">Campo obrigatório.</p>
                        </div>
                        <div class="label__field" style="width: 40%">
                            <label class="label" for="cnpj">CNPJ*</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmenteParticipante" v-model="participante.CustodianteCnpj" id="cnpj" placeholder="00.000.000/0000-00">
                            <p v-if="camposObrigatorios.erroParticipanteCustodianteCnpj" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="cpf">Código CBLC*</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmenteParticipante" v-model="participante.CustodianteCBLC" id="representanteLegal">
                            <p v-if="camposObrigatorios.erroParticipanteCustodianteCBLC" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="formularioOutrosParticipantes">
            <div class="titleForm" style="display: inline-flex; width: 100%">
                <div v-if="!listaRepresentantes.length > 0" style="width: 100%">
                    <LabelDisclaimer :TamanhoFonteLabel="'H3'" :NomeLabel="'Outros participantes'" :TipoCliente="'Fundos'" :Sessao="'Participantes'" :SubSessao="'Outros participantes'" />
                    <h5>Clique em adicionar e selecione entre as opções: Diretor ou Administrador.</h5>
                </div>
                <div v-if="listaRepresentantes.length > 0" style="width: 90%">
                    <h3>Outros participantes</h3>
                    <h5>Clique em adicionar e selecione entre as opções Diretor ou Administrador.</h5>
                </div>
                <div v-if="listaRepresentantes.length > 0" style="width: 5%; margin-top: 40px;">
                    <button class="btnBlue" @click="addParticipante()">+ Adicionar</button>
                </div>
            </div>
            <div class="titleForm">
                <div class="opcoesForm" v-if="!listaRepresentantes.length > 0" style="margin-bottom: 10px">
                    <img src="@/assets/addRepresentante.png" />
                    <h3>Nenhum participante adicionado</h3>
                    <h5>Clique em adicionar e selecione entre as opções Diretor ou Administrador.</h5>
                    <button class="btnBlue" @click="addParticipante()">+ Adicionar</button>
                </div>
                <div v-if="listaRepresentantes.length > 0">
                    <table class="table">
                        <thead>
                            <th style="width: 20%">Nome</th>
                            <th style="width: 11%">Tipo</th>
                            <th style="width: 15%">CPF/CNPJ</th>
                            <th style="width: 15%">Telefone</th>
                            <th style="width: 15%">E-mail</th>
                            <th style="width: 14%">Assinatura</th>
                            <th style="width: 10%">&nbsp;</th>
                        </thead>
                        <tbody>
                            <tr v-for="(representanteObj, index) in listaRepresentantes" :key="index">
                                <td>{{ representanteObj.Nome }}</td>
                                <td>{{ representanteObj.Tipo }}</td>
                                <td>{{ formatCpfCnpj(representanteObj.CpfCnpj) }}</td>
                                <td>{{ representanteObj.Telefone }}</td>
                                <td>{{ representanteObj.Email }}</td>
                                <td>{{ representanteObj.Assinatura }}</td>
                                <td>
                                    <div class="widget icons" style="display: inline-flex">
                                        <a @click.stop.prevent="editarParticipante(index)" class="ico__edit" title="editar">
                                            <Icon icon="ico-edit" />
                                        </a>
                                        <a @click.stop.prevent="excluirParticipante(index)" class="ico__delete" title="deletar" style="margin-left: 5px"></a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="footerFormulario">
            <div class="buttonsAcoes">
                <button class="btnDefault" @click="salvarInformacoes" v-if="this.Edicao != true">Salvar e continuar depois</button>
                <button class="btnDefault" @click="salvarInformacoes" v-if="this.Edicao == true">Salvar</button>
                <button class="btnBlue" v-if="!Edicao" @click="proximaEtapa">Avançar</button>
            </div>
        </div>
        <ModalAddParticipante />
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import api from '@/api/axios';
import formatCpfCnpj from '@/utils/formatCpfCnpj'
import ModalAddParticipante from './ModalAddParticipante.vue'
import LabelDisclaimer from '../Utilitarios/Disclaimer/LabelDisclaimer.vue'
export default {
    name: 'CadastroOutros_Participantes',
    mixins: [formatCpfCnpj],
    props: ['informacoesParticipantes', 'Edicao', 'emissoresDeOrdensBD'],
    components: { ModalAddParticipante, LabelDisclaimer },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            listaRepresentantes: 'GET_LISTA_PARTICIPANTES_FI',
            listaDeRepresentantes: 'GET_FI_INFO_PARTICIPANTE_REPRESENTANTE',
        }),
    },
    data() {
        return {
            permitirAvancar: false,
            camposObrigatorios: {
                erroParticipanteAdministrador: false,
                erroParticipanteAdministradorCnpj: false,
                erroParticipanteGestor: false,
                erroParticipanteGestorCnpj: false,
                erroParticipanteCustodiante: false,
                erroParticipanteCustodianteCnpj: false,
                erroParticipanteCustodianteCBLC: false,
            },
            //camposObrigatoriosRepresentante: [],
            camposObrigatoriosRepresentante: [{
                erroNome: false,
                erroCnpj: false,
                 erroAssinatura: false
            }],
            //camposObrigatoriosGestor: [],
            camposObrigatoriosEmissor: [],
            participante: this.informacoesParticipantes,
            informacoesParticipantesRepresentantes: this.listaDeRepresentantes,
            representantes: [],
            emissoresDeOrdens: [],
            nomeRepresentante: {
                Guid: '',
                ClienteId: null,
                Nome: '',
                CpfCnpj: '',
                Tipo: '',
                Email: '',
                Cargo: '',
                Telefone: ''
            },
        }
    },
    mounted() {
        this.$store.commit('SET_MODAL_FI_ADD_PARTICIPANTE', false);
        this.$store.dispatch('FETCH_FI_INFO_PARTICIPANTE_REPRESENTANTE', this.user.ClienteId);
        this.informacoesParticipantesRepresentantes = this.listaDeRepresentantes;
        var possuiGestor = this.informacoesParticipantesRepresentantes.some(representante => representante.Tipo === 'gestor' || representante.Tipo == "Gestor");
        var possuiAdministrador = this.informacoesParticipantesRepresentantes.some(representante => representante.Tipo === 'representanteAdministrador');
        var possuiEmissorOrdem = this.emissoresDeOrdensBD.length > 0 ? true : false;
        this.emissoresDeOrdens = this.emissoresDeOrdensBD;
        if (!possuiEmissorOrdem) {
            this.addEmisorOrdem();
        }
        if (possuiGestor && possuiAdministrador) {
            this.representantes = this.informacoesParticipantesRepresentantes;
        } else {
            if (!possuiGestor && !possuiAdministrador) {
                this.addRepresentanteGestor();
                this.addRepresentanteAdmin();
            }
            if (!possuiGestor) {
                this.representantes = this.informacoesParticipantesRepresentantes;
                this.addRepresentanteGestor();
            }
            if (!possuiAdministrador) {
                this.representantes = this.informacoesParticipantesRepresentantes;
                this.addRepresentanteAdmin();
            }
        }
        //this.validarFormulario();
        this.inicializarCamposObrigatoriosRepresentante();
        //this.inicializarCamposObrigatoriosGestor();
        this.inicializarCamposObrigatoriosEmissor();
    },
    watch: {
        listaDeRepresentantes() {
            this.informacoesParticipantesRepresentantes = this.listaDeRepresentantes;
            var possuiGestor = this.informacoesParticipantesRepresentantes.some(representante => representante.Tipo === 'gestor' || representante.Tipo == "Gestor");
            var possuiAdministrador = this.informacoesParticipantesRepresentantes.some(representante => representante.Tipo === 'representanteAdministrador');
            var possuiEmissorOrdem = this.emissoresDeOrdensBD.length > 0 ? true : false;
            this.emissoresDeOrdens = this.emissoresDeOrdensBD;
            if (!possuiEmissorOrdem) {
                this.addEmisorOrdem();
            }
            if (possuiGestor && possuiAdministrador) {
                this.representantes = this.informacoesParticipantesRepresentantes;
            } else {
                if (!possuiGestor && !possuiAdministrador) {
                    this.addRepresentanteGestor();
                    this.addRepresentanteAdmin();
                }
                if (!possuiGestor) {
                    this.representantes = this.informacoesParticipantesRepresentantes;
                    this.addRepresentanteGestor();
                }
                if (!possuiAdministrador) {
                    this.representantes = this.informacoesParticipantesRepresentantes;
                    this.addRepresentanteAdmin();
                }
            }
        },
        representantes: {
            handler(newRepresentante) {
                this.camposObrigatoriosRepresentante = newRepresentante.map(() => ({
                    erroNome: false,
                    erroCnpj: false,
                    erroAssinatura: false
                }));
            },
            immediate: true
        },
        emissoresDeOrdens: {
            handler(newEmissoresDeOrdens) {
                this.camposObrigatoriosEmissor = newEmissoresDeOrdens.map(() => ({
                    erroNome: false,
                    erroCnpj: false,
                    erroAssinatura: false
                }));
            },
            immediate: true
        }
    },
    methods: {
        addParticipante() {
            this.$store.commit('SET_MODAL_FI_EDITAR_PARTICIPANTE', null);
            this.$store.commit('SET_MODAL_FI_ADD_PARTICIPANTE', true);
        },
        editarParticipante(index) {
            this.$store.commit('SET_MODAL_FI_EDITAR_PARTICIPANTE', this.listaRepresentantes[index]);
            this.$store.commit('SET_MODAL_FI_ADD_PARTICIPANTE', true);
        },
        async excluirEmissorOrdem(index) {
            var encodedCredentials = btoa('sat@sat:sat23!');
            if (this.emissoresDeOrdens[index].Guid == '') {
                this.emissoresDeOrdens.splice(index, 1);
                this.$store.commit('SET_FI_SALVAR_INFO_EMISSOR_ORDEM', this.emissoresDeOrdens);
                this.$swal({
                    icon: 'success',
                    title: 'Exclusão realizada com sucesso!',
                    text: 'Dados informados foram excluídos com sucesso.',
                });
                return;
            }
            await api.get(`fundo/pessoaAutorizadaEmitirOrdem/excluir?guid=${this.emissoresDeOrdens[index].Guid}`, { headers: { 'Authorization': `Basic ${encodedCredentials}` } })
                .then((retorno) => {
                    if (retorno.status == 200) {
                        this.$swal({
                            icon: 'success',
                            title: 'Exclusão realizada com sucesso!',
                            text: 'Dados informados foram excluídos com sucesso.',
                        });
                        this.$store.dispatch('FETCH_FI_INFO_EMISSOR_ORDEM', this.user.ClienteId);
                    }
                })
                .catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: 'Dados informados inválidos.',
                        text: `${error.response.data.data[0]}`,
                    });
                });
        },
        async excluirParticipante(index) {
            var encodedCredentials = btoa('sat@sat:sat23!');
            await api.get(`fundo/emissorOrdem/excluir?guid=${this.listaRepresentantes[index].Guid}`, { headers: { 'Authorization': `Basic ${encodedCredentials}` } })
                .then((retorno) => {
                    if (retorno.status == 200) {
                        this.$swal({
                            icon: 'success',
                            title: 'Exclusão realizada com sucesso!',
                            text: 'Dados informados foram excluídos com sucesso.',
                        });
                        this.$store.dispatch('FETCH_FI_INFO_PARTICIPANTE_CUSTODIANTE', this.user.ClienteId);
                        this.validarFormulario();
                    }
                })
                .catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: 'Dados informados inválidos.',
                        text: `${error.response.data.data[0]}`,
                    });
                });
        },
        proximaEtapa() {
            this.validarFormulario(true);
            if (this.permitirAvancar) {
                this.$store.commit('SET_ETAPA_CADASTRO', 3);
            }
        },
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            this.tentativaPostagem = submeter;
            var nomeDoCampo = '';
            this.camposObrigatorios = {
                erroParticipanteAdministrador: false,
                erroParticipanteAdministradorCnpj: false,
                erroParticipanteGestor: false,
                erroParticipanteGestorCnpj: false,
                erroParticipanteCustodiante: false,
                erroParticipanteCustodianteCnpj: false,
                erroParticipanteCustodianteCBLC: false,
            };
            if (!this.participante.Administrador) {                
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroParticipanteAdministrador = true;
                    nomeDoCampo = 'Denominação social do Administrador';                    
                }
                this.permitirAvancar = false;
            }
            if (!this.participante.AdministradorCnpj) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroParticipanteAdministradorCnpj = true;
                    nomeDoCampo = 'CNPJ do Administrador';
                }
                this.permitirAvancar = false;
            }            
            if (!this.participante.Gestor) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroParticipanteGestor = true;
                    nomeDoCampo = 'Denominação social ou Nome completo do Gestor';
                }
                this.permitirAvancar = false;
            }
            if (!this.participante.GestorCnpj) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroParticipanteGestorCnpj = true;
                    nomeDoCampo = 'CNPJ do Gestor';
                }
                this.permitirAvancar = false;
            }
            this.representantes.forEach((obj, index) => {                
                if (!obj.Nome) {
                    this.camposObrigatoriosRepresentante[index].erroNome = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') 
                        nomeDoCampo = 'Nome do ' + (obj.Tipo == 'representanteAdministrador' ? 'representante legal do Administrador' : 'representante legal do Gestor');                    
                    return;
                } else {
                    this.camposObrigatoriosRepresentante[index].erroNome = false;
                }                
                if (!obj.CpfCnpj) {
                    this.camposObrigatoriosRepresentante[index].erroCnpj = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') 
                        nomeDoCampo = 'CNPJ do ' + (obj.Tipo == 'representanteAdministrador' ? 'representante legal do Administrador' : 'representante legal do Gestor');
                    return;
                } else {
                    this.camposObrigatoriosRepresentante[index].erroCnpj = false;
                }
                if (obj.Assinatura === null || obj.Assinatura === undefined || obj.Assinatura === '') {
                    this.camposObrigatoriosRepresentante[index].erroAssinatura = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') 
                        nomeDoCampo = 'Assinatura do ' + (obj.Tipo == 'representanteAdministrador' ? 'representante legal do Administrador' : 'representante legal do Gestor');
                    return;
                } else {
                    this.camposObrigatoriosRepresentante[index].erroAssinatura = false;
                }
            });     
            this.emissoresDeOrdens.forEach((obj, index) => {
                if (!obj.Nome) {
                    this.camposObrigatoriosEmissor[index].erroNome = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = 'Nome do Emissor de Ordem';
                    return;
                } else {
                    this.camposObrigatoriosEmissor[index].erroNome = false;
                }
                if (!obj.CpfCnpj) {
                    this.camposObrigatoriosEmissor[index].erroCpfCnpj = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = 'CNPJ do Emissor de Ordem';
                    return;
                } else {
                    this.camposObrigatoriosEmissor[index].erroCpfCnpj = false;
                }
                if (obj.Assinatura === null || obj.Assinatura === undefined || obj.Assinatura === '') {
                    this.camposObrigatoriosEmissor[index].erroAssinatura = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = 'Assinatura do Emissor de Ordem';
                    return;
                } else {
                    this.camposObrigatoriosEmissor[index].erroAssinatura = false;
                }
            });
            if (!this.participante.Custodiante) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroParticipanteCustodiante = true;
                    nomeDoCampo = 'Denominação social ou Nome completo do Custodiante';
                }
                this.permitirAvancar = false;
            }
            if (!this.participante.CustodianteCnpj) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroParticipanteCustodianteCnpj = true;
                    nomeDoCampo = 'CNPJ do Custodiante';
                }
                this.permitirAvancar = false;
            }
            if (!this.participante.CustodianteCBLC) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroParticipanteCustodianteCBLC = true;
                    nomeDoCampo = 'CBLC do Custodiante';
                }
                this.permitirAvancar = false;
            }                   
            if (submeter && nomeDoCampo != '') {
                this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo ` + nomeDoCampo + ` não foi informado, preencha a informação para avançar.`,
                });
            }
        },
        salvarInformacoes() {
            this.$store.commit('SET_FI_SALVAR_INFO', true);
        },
        salvarAlteracoesLocalmenteParticipante() {
            this.$store.commit('SET_FI_SALVAR_INFO_PARTICIPANTE', this.participante);
            this.validarFormulario();
        },
        salvarAlteracoesLocalmenteRepresentante() {
            this.$store.commit('SET_FI_SALVAR_INFO_PARTICIPANTE_REPRESENTANTE', this.representantes);
            this.validarFormulario();
        },
        salvarAlteracoesLocalmenteEmissorOrdem() {
            this.$store.commit('SET_FI_SALVAR_INFO_EMISSOR_ORDEM', this.emissoresDeOrdens);
            this.validarFormulario();
        },
        addEmisorOrdem() {
            this.emissor = { Guid: '', ClienteId: this.user.ClienteId, Nome: '', CpfCnpj: '', Telefone: '', Email: '', Cargo: '', UsPerson: "false", PoliticamenteExposta: "false" };
            this.emissoresDeOrdens.push({ ...this.emissor });
            if (!this.camposObrigatoriosEmissor) this.camposObrigatoriosEmissor = [];
            this.camposObrigatoriosEmissor.push({
                erroNome: false,
                erroCpfCnpj: false,
                erroAssinatura: false
            });
        },
        addRepresentanteGestor() {
            this.novoRepresentante = { Guid: '', ClienteId: this.user.ClienteId, Nome: '', CpfCnpj: '', Tipo: 'gestor', Telefone: '', Email: '', Cargo: '', Signatario: "false", Assinatura: '' };
            this.representantes.push({ ...this.novoRepresentante });
            if (!this.camposObrigatoriosRepresentante) this.camposObrigatoriosRepresentante = [];
            this.camposObrigatoriosRepresentante.push({
                erroNome: false,
                erroCpfCnpj: false,
                erroAssinatura: false
            });
        },
        addRepresentanteAdmin() {
            this.novoRepresentante = { Guid: '', ClienteId: this.user.ClienteId, Nome: '', CpfCnpj: '', Tipo: 'representanteAdministrador', Telefone: '', Email: '', Cargo: '', Signatario: "false", Assinatura: '' };
            this.representantes.push({ ...this.novoRepresentante });
            if (!this.camposObrigatoriosRepresentante) this.camposObrigatoriosRepresentante = [];
            this.camposObrigatoriosRepresentante.push({
                erroNome: false,
                erroCpfCnpj: false,
                erroAssinatura: false
            });
        },
        async excluirRepresentante(index) {
            var encodedCredentials = btoa('sat@sat:sat23!');
            if (this.representantes[index].Guid == '') {
                this.representantes.splice(index, 1);
                this.$store.commit('SET_FI_SALVAR_INFO_PARTICIPANTE_REPRESENTANTE', this.representantes);
                this.validarFormulario();
            } else {
                await api.get(`fundo/representante/excluir?guid=${this.representantes[index].Guid}&tipo=${this.representantes[index].Tipo}`, { headers: { 'Authorization': `Basic ${encodedCredentials}` } })
                    .then((retorno) => {
                        if (retorno.status == 200) {
                            this.validarFormulario();
                            this.$swal({
                                icon: 'success',
                                title: 'Exclusão realizada com sucesso!',
                                text: 'Dados informados foram excluídos com sucesso.',
                            });
                            this.representantes.splice(index, 1);
                            this.$store.commit('SET_FI_SALVAR_INFO_PARTICIPANTE_REPRESENTANTE', this.representantes);
                        }
                    })
                    .catch((error) => {
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos.',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
            }
        },
        inicializarCamposObrigatoriosRepresentante() {
            this.camposObrigatoriosRepresentante = this.representantes.map(() => ({
                erroNome: false,
                erroCpfCnpj: false,
                erroAssinatura: false
            }));
        },
        inicializarCamposObrigatoriosEmissor() {
            this.camposObrigatoriosEmissor = this.emissoresDeOrdens.map(() => ({
                erroNome: false,
                erroCpfCnpj: false,
                erroAssinatura: false
            }));
        }
    }
}
</script>

<!--<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.btnBlue {
    height: 40px;
    font-family: 'Inter', sans-serif;
    /* Fonte Inter */
    background-color: #00235C;
    color: white;
    border: 1px solid #00235C;
    /* Borda */
    border-radius: 8px;
    /* Raio de borda */
    width: 100px;
    cursor: pointer;
}

.formulario {
    width: 100%;
}

.btnBlueUpload {
    height: 40px;
    font-family: 'Inter', sans-serif;
    /* Fonte Inter */
    background-color: #00235C;
    border: 1px solid #00235C;
    /* Borda */
    border-radius: 8px;
    /* Raio de borda */
    widows: 88px;
    cursor: pointer;
}

.formularioOutrosParticipantes {
    margin-top: 20px;
    width: 100%;
    margin-bottom: 10px;
    font-family: 'Inter', sans-serif;
    /* Fonte Inter */
    border: 1px solid #EAECF0;
    border-radius: 8px;
    /* Raio de borda */

    .titleForm {
        background-color: white;
        border-bottom: 1px solid #EAECF0;

        h3 {
            margin-left: 20px;
            color: #101828;
            font-weight: 500;
            font-family: 'Inter', sans-serif;
        }

        h5 {
            margin-top: 5px;
            margin-left: 20px;
            margin-block-start: 0;
            color: #667085;
            font-weight: 500;
            font-family: 'Inter', sans-serif;
        }
    }

    .resumoForm {
        width: 100%;

        .opcoesForm {
            margin-left: 30%;
            display: grid;
            justify-content: space-between;
            align-content: space-between;
            align-items: center;
            justify-items: center;

            h5 {
                margin-top: 5px;
                margin-block-start: 0;
                color: #667085;
                font-weight: 500;
                font-family: 'Inter', sans-serif;
            }

            img {
                height: 48px;
                width: 48px;

            }

            .btnBlue {
                height: 40px;
                font-family: 'Inter', sans-serif;
                /* Fonte Inter */
                background-color: #00235C;
                color: white;
                border: 1px solid #00235C;
                /* Borda */
                border-radius: 8px;
                /* Raio de borda */
                width: 350px;
                cursor: pointer;
            }
        }
    }
}

.agrupamentoFormulario {
    width: 100%;
    display: inline-flex;
    margin-top: 10px;
    /* Borda */
}

.categoriaAgrupamentoFormulario {
    width: 13%;
    margin-right: 15px;
    font-family: 'Inter', sans-serif;
    /* Fonte Inter */

    span {
        font-weight: 400 !important;
        font-size: 13px;
        color: #667085;
    }
}

.label__field {
    padding-right: 30px;
}

.camposAgrupamentoFormulario {
    width: 90%;

    .row {
        width: 100%;
        display: inline-flex;
        gap: 8px;
        margin-bottom: 10px;
    }

    .accept {
        display: inline-flex;
        &:checked {
            +label {
                &:before {
                    background: white;
                    border: 1px solid black;
                    transition: background 0.3s;
                }
            }
            +label {
                &::after {
                    opacity: 1;
                    transition: all;
                    background: transparent;
                }
            }
        }
    }

    .radio {
        display: flex;
        align-items: center;
        margin-right: 25px;
        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }

        .field__radio {
            width: 20px;
            height: 20px;
        }

        .fieldInRadio {
            border-radius: 8px;
            /* Raio de borda */
            border: 1px solid #D0D5DD;
            /* Borda */
            padding: 10px 14px;
            /* Preenchimento interno */
            background-color: #F9FAFB;
            /* Cor de fundo */
            width: 55%;
        }

        .label__radio {
            margin-left: 5px;
            margin-right: 40px;
            margin-top: 5px;
        }
    }

    select {
        width: 105% !important;
    }

    label {
        font-family: 'Inter', sans-serif;
        /* Fonte Inter */
        font-weight: 500;
        /* Peso médio */
        font-size: 14px;
        /* Tamanho da fonte */
        line-height: 20px;
        /* Altura da linha */
        color: #344054;
        /* Cor */
        display: block;
        /* Garante que a label fique acima do input */
        margin-bottom: 8px;
        /* Espaçamento entre a label e o input abaixo dela */
    }
}





.title {

    border-bottom: 1px solid #EAECF0;

    h3 {
        margin-top: 50px;
        color: #101828;
        font-weight: 500;
        font-family: 'Inter', sans-serif;

    }

    h5 {
        margin-top: 5px;
        margin-block-start: 0;
        color: #667085;
        font-weight: 400;
        font-family: 'Inter', sans-serif;
    }
}
</style>-->